module.exports = __webpack_public_path__ + "static/media/RA-KV0404B_03.909b3a5b.png";